import React, { useId, useState } from "react";

interface FeedbackModalProps {
	isOpen: boolean;
	onClose: () => void;
	onSubmit: (feedback: string) => void;
}

export const FeedbackModal = ({
	isOpen,
	onClose,
	onSubmit,
}: FeedbackModalProps) => {
	const [feedbackText, setFeedbackText] = useState("");
	const id = useId();

	if (!isOpen) {
		return null;
	}

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		if (feedbackText.trim()) {
			onSubmit(feedbackText);
			setFeedbackText(""); // Clear textarea after submit
		}
	};

	const handleBackdropKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === "Escape") {
			onClose();
		}
	};

	const handleContentKeyDown = (e: React.KeyboardEvent) => {
		e.stopPropagation();
	};

	return (
		<div
			className="fixed inset-0 bg-black/50 flex justify-center items-center z-[2000]"
			role="dialog"
			aria-modal="true"
			aria-labelledby={`${id}-title`}
			aria-describedby={`${id}-description`}
			tabIndex={-1}
			onClick={onClose}
			onKeyDown={handleBackdropKeyDown}
		>
			<div
				className="bg-white rounded-24 shadow-lg min-w-[300px] max-w-[800px] w-full font-rubik p-16"
				role="document"
				onClick={(e) => e.stopPropagation()}
				onKeyDown={handleContentKeyDown}
			>
				<h2 id={`${id}-title`} className="mt-0 mb-6 text-2xl">
					Feedback Form
				</h2>
				<p id={`${id}-description`} className="mb-6 text-base">
					We value your feedback. Please share your thoughts with us so we can
					improve our service.
				</p>
				<form onSubmit={handleSubmit} className="flex flex-col">
					<textarea
						className="w-full p-3 border border-[#ccc] rounded-16 mb-4 text-base resize-y"
						value={feedbackText}
						onChange={(e) => setFeedbackText(e.target.value)}
						placeholder="Your feedback helps us improve..."
						rows={5}
						required
					/>
					<div className="flex justify-end gap-2">
						<button
							type="button"
							onClick={onClose}
							className="px-5 py-2.5 rounded-24 text-base bg-grayscale-100 text-grayscale-950 transition-colors hover:bg-grayscale-200 border-0 cursor-pointer"
						>
							Cancel
						</button>
						<button
							type="submit"
							className="px-5 py-2.5 rounded-24 text-base bg-primary-500 text-white transition-colors hover:bg-primary-600 border-0 cursor-pointer"
						>
							Submit
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};
